import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Card, CardContent, CardActionArea, Grid, Typography, Container } from '@material-ui/core'
import { AccountCircle, Build } from '@material-ui/icons'
import { GenericTemplate } from '../../templates'
import { HeaderBar } from '../../organisms'
import { PageHeader } from '../../molecules'

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(4),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardContent: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4),
  },
  icon: {
    fontSize: 80,
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  cardTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 'bold',
  },
  cardDescription: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}))

export const HomePagePresenter: FC = () => {
  const classes = useStyles()
  const history = useHistory()

  return (
    <GenericTemplate headerBar={<HeaderBar />}>
      <PageHeader>
        <Typography variant="h3" component="h1">
          ホーム
        </Typography>
      </PageHeader>
      <Container maxWidth="md" className={classes.container}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <Card className={classes.card}>
              <CardActionArea onClick={() => history.push('/select-account')} style={{ height: '100%' }}>
                <CardContent className={classes.cardContent}>
                  <AccountCircle className={classes.icon} />
                  <Typography variant="h5" component="h2" className={classes.cardTitle}>
                    アカウント管理
                  </Typography>
                  <Typography variant="body2" className={classes.cardDescription}>
                    各テナントのリッチメニュー、オーディエンス抽出、キャンペーンエントリー操作
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Card className={classes.card}>
              <CardActionArea onClick={() => history.push('/tol-operations')} style={{ height: '100%' }}>
                <CardContent className={classes.cardContent}>
                  <Build className={classes.icon} />
                  <Typography variant="h5" component="h2" className={classes.cardTitle}>
                    ToL運用管理
                  </Typography>
                  <Typography variant="body2" className={classes.cardDescription}>
                    お知らせ管理・OTAC死活監視設定
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </GenericTemplate>
  )
}
